export const acceptedFileTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/tiff",
    "image/tiff",
    "application/pdf",
    "application/rtf",
]


// WEBPACK FOOTER //
// ./src/components/Common/CommonUpload/uploadHelper.js